import {isAllowedSuperadminOverride} from 'common/report/util/saved-entities';
import {Content} from 'common/types/app-api/content';

export const contentUtils = {
  canEditContent,
};

function canEditContent(content: Pick<Content, `allow_staff_override` | `is_superadmin` | `can_update_basic`>) {
  return content.can_update_basic || isAllowedSuperadminOverride(content);
}
